import styled from 'styled-components';
import { ButtonBorderRadius } from '~/components/ui/Button';

const ResultContainer = styled.div`
	flex: 1;
	min-height: 120px;
	max-height: 180px;
	display: flex;
	flex-direction: column;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: ${ButtonBorderRadius.Radius10}px;
	overflow: hidden;
`;

const ResultHeader = styled.div`
	padding: 10px 15px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
	background-color: rgba(255, 255, 255, 0.03);
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const ResultLabel = styled.div`
	font-family: 'GT Walsheim Pro';
	font-size: 12px;
	font-weight: 600;
	color: rgba(255, 255, 255, 0.5);
	text-transform: uppercase;
	letter-spacing: 0.5px;
	user-select: none;
`;

const CopyButton = styled.button`
	width: 20px;
	height: 20px;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 0;
	background: transparent;
	opacity: 0.45;
	cursor: pointer;
	transition: opacity 0.15s ease;

	img {
		width: 14px;
		height: 14px;
	}

	&:hover {
		opacity: 1;
	}

	&:disabled {
		opacity: 0.15;
		cursor: default;
	}
`;

const ResultText = styled.div`
	flex: 1;
	padding: 15px;
	overflow: auto;
	font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
	font-size: 13px;
	line-height: 1.5;
	color: #4caf50;
	white-space: pre-wrap;
	word-break: break-word;
	user-select: text;
	cursor: text;

	&::-webkit-scrollbar {
		width: 8px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: rgba(255, 255, 255, 0.1);
		border-radius: 4px;

		&:hover {
			background-color: rgba(255, 255, 255, 0.2);
		}
	}
`;

const ErrorText = styled.div`
	flex: 1;
	padding: 15px;
	overflow: auto;
	font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
	font-size: 13px;
	line-height: 1.5;
	color: #c71e1e;
	white-space: pre-wrap;
	word-break: break-word;
	user-select: text;
	cursor: text;

	&::-webkit-scrollbar {
		width: 8px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: rgba(255, 255, 255, 0.1);
		border-radius: 4px;

		&:hover {
			background-color: rgba(255, 255, 255, 0.2);
		}
	}
`;

const NoOutputText = styled.div`
	flex: 1;
	padding: 15px;
	overflow: auto;
	font-family: 'GT Walsheim Pro';
	font-size: 13px;
	line-height: 1.5;
	color: rgba(255, 255, 255, 0.25);
	font-style: italic;
	user-select: text;
	cursor: text;
`;

export {
	CopyButton,
	ErrorText,
	NoOutputText,
	ResultContainer,
	ResultHeader,
	ResultLabel,
	ResultText,
};
